'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["input", "label"];
import { render } from 'foundations-components/transitional/utils/customRenderer';
import { lazyEval } from 'foundations-components/transitional/utils/lazyEval';
import { Component } from 'react';
export default class SingleNameInput extends Component {
  render() {
    const _this$props = this.props,
      {
        input,
        label
      } = _this$props,
      passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return render(input, Object.assign({
      label: lazyEval(label)
    }, passThroughProps, input.props), {
      mergeType: 'aggressive'
    });
  }
}